import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DialogService } from '@shared/components/dialog';
import { catchError, firstValueFrom, of } from 'rxjs';
import { DOCS_STRUCTURE } from '../../content';
import { DocItemDto } from './models/doc-item.dto';
import { DocStructure } from './models/doc-structure';

@Injectable({
  providedIn: 'root'
})
export class DocsService {
  /** Cliente sem interceptors — evita baseUrl prefixar apiUrl em arquivos estáticos (assets). */
  private readonly assetHttp = new HttpClient(inject(HttpBackend));
  private readonly dialogService = inject(DialogService);

  public getStructure(): DocStructure {
    return DOCS_STRUCTURE;
  }

  public open(): void {
    import('../../components/docs-dialog/docs-dialog.component').then(m => {
      this.dialogService.create({
        content: m.DocsDialogComponent,
        data: {}
      });
    });
  }

  public async loadMarkdown(path: string): Promise<string> {
    const url = path.startsWith('/') ? path : `/${path}`;
    try {
      return await firstValueFrom(this.assetHttp.get(url, { responseType: 'text' }).pipe(catchError(() => of(''))));
    } catch {
      return '';
    }
  }

  public searchDocs(query: string): DocStructure {
    if (!query || query.trim() === '') {
      return this.getStructure();
    }

    const normalizedQuery = query.toLowerCase().trim();
    const filteredSections: DocItemDto[] = [];

    for (const section of DOCS_STRUCTURE.sections) {
      const matchingChildren: DocItemDto[] = [];

      if (section.children) {
        for (const child of section.children) {
          if (child.title.toLowerCase().includes(normalizedQuery)) {
            matchingChildren.push(child);
          }
        }
      }

      if (matchingChildren.length > 0) {
        filteredSections.push({
          ...section,
          children: matchingChildren
        });
      } else if (section.title.toLowerCase().includes(normalizedQuery)) {
        filteredSections.push(section);
      }
    }

    return { sections: filteredSections };
  }

  public flattenDocs(structure: DocStructure): DocItemDto[] {
    const result: DocItemDto[] = [];

    for (const section of structure.sections) {
      result.push(section);
      if (section.children) {
        result.push(...section.children);
      }
    }

    return result;
  }
}
